import { ReactComponent as SoundOnIcon } from "components/icons/soundOnIcon.svg";
import { ReactComponent as SoundOffIcon } from "components/icons/soundOffIcon.svg";
import "./SoundButton.scss";

interface ISoundButtonProps {
  enabled: boolean;
  onClick: () => void;
}

export const SoundButton: React.FC<ISoundButtonProps> = ({ enabled, onClick }) => {
  return (
    <button className="SoundButton" onClick={onClick}>
      {enabled ? (
        <SoundOnIcon />
      ) : (
        <SoundOffIcon />
      )}

      <div className="label">{enabled ? "On" : "Off"}</div>
    </button>
  );
};
